module.exports = __webpack_public_path__ + "static/media/cloud-showers-heavy.03972ef9.svg";